import React from 'react';
import { AccordionSummary, useTheme } from '@mui/material';

const DSAccordionSummary = (
  props: React.ComponentProps<typeof AccordionSummary>,
) => {
  const { spacing } = useTheme();

  return (
    <AccordionSummary
      {...props}
      sx={{
        backgroundColor: 'transparent',
        padding: spacing(2),
        borderRadius: 0,
        '& .MuiAccordionSummary-content': {
          '&.Mui-expanded': {
            margin: '10px 0',
          },
        },
        ...props.sx,
      }}
    />
  );
};

export default DSAccordionSummary;
